<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-bar head-title" style="display: flex;align-items: center;">
        在建项目复工信息表
      </div>
      <div class="build-bar" style="height: 8vh;display: flex;align-items: center;align-content: center;justify-content: flex-start;">
        <el-input placeholder="请输入工程名称" v-model="search.projectName" style="margin-left:20px;"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
      </div>
      <div class="build-table">
        <el-table
          :data="listData"
          border
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column
            type="index"
            label="序号"
            width="60">
          </el-table-column>
          <el-table-column label="项目名称">
            <template slot-scope="scope">
              <a>{{ scope.row.projectname}}</a>
            </template>
          </el-table-column>
          <el-table-column label="疫情防控负责人（姓名）" width="280">
            <template slot-scope="scope">
              <span>{{ scope.row.yqname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.yqphone }}</span>
            </template>
          </el-table-column>

          <el-table-column label="防控物资">
            <template slot-scope="scope">
              <span v-if="scope.row.tbname!='' && scope.row.tbname">有</span>
              <span v-else-if="scope.row.tbname && scope.row.tbname=='无'" style="color:red;">无</span>
              <span></span>
            </template>
          </el-table-column>
          <el-table-column label="测温设备">
            <template slot-scope="scope">
              <span v-if="scope.row.tbname!='' && scope.row.tbname">有</span>
              <span v-else-if="scope.row.tbname && scope.row.tbname=='无'" style="color:red;">无</span>
            </template>
          </el-table-column>
          <el-table-column label="人员登记">
            <template slot-scope="scope">
              <span>{{ scope.row.tbname }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="报表上报连线人">
            <template slot-scope="scope">
              <span>{{ scope.row.tbname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.tbphone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="施工管理人员复工时间">
            <template slot-scope="scope">
              <span>{{ scope.row.manageWorkTime }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="资料上传">
            <template slot-scope="scope">
              <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>
          <el-table-column label="同意  不同意">
            <template slot-scope="scope">
              <span v-if="scope.row.approval=='0'" style="color:#4263F3;">等待审批</span>
              <span v-else-if="scope.row.approval=='1'" style="color:#00C850;">同意复工</span>
              <span v-else-if="scope.row.approval=='2'" style="color:#FF8001;">不同意复工</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="管理">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>

        <!-- 分页展示 -->
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination> -->
      </div>
    </div>
    
    
  </div>
</template>

<script>
import myHttp from "../../../untils/port.js"
import util from "../../../untils/util.js"
import base from '../../../untils/base'
export default {
  data() {
    return {
      search:{  //查询
        projectName:'',
        entId:'',
        projectType:'',
      },
      listData:[], //表格数据
      // options:[{
      //   id:'1',
      //   name:'经开区'
      // }],
      flags:[
        {id:'1',name:'房建'},
        {id:'2',name:'市政'}
      ],
      entId:'',
      dataText:'数据加载中...',
    }
  },
  mounted(){
    // this.supId = this.$store.state.groupId;
    // if(''==this.entId){
    //   this.$store.commit('setGroupId');
    //   this.entId = this.$store.state.groupId;
    // }
    this.entId = util.session.get('groupId')
    this.search.entId = this.entId
    // this.search.projectType = util.session.get('roleId')=='3'?''
    this.getData();
    
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.getData()
    },
    //获取所属区域
    // getCurArea(){
    //   var that = this;
    //   myHttp.getSuperviseById({id:this.entId}).then(function(resp){
    //     if(resp.data.code=="200"){
    //       that.search.areaId = resp.data.data.supervise.areaId;
    //       that.getData();
    //     }
    //   },function(){});
    // },
    // 获取数据
    getData() {
      var that = this;
      myHttp.getEntBackWorkList(this.search).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.entity||[];
            if(list.length==0 && that.entId=='1263382107619520513'){
              list = [{index:1},{index:2},{index:3},{index:4},{index:5},{index:6},{index:7},{index:8},{index:9}]
            }
            that.listData = list;
            if(that.listData.length==0){
                that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    //导出
    exportOut(){
      var token = this.$store.state.token;
      window.open(myHttp.exportBackWork+'?areaId=&projectType='+this.search.projectType+'&accessToken='+token);
    },
    /**
     * 获取项目
     */
    getProject(){
      var that = this;
        myHttp.getProjectPage({
          pageNum:1,
          pageSize:1000
        }).then(function(resp){
          if(resp.data.code=="200"){
             var list = resp.data.data.pageInfo.list;
             that.projects = list;
          }else{
            that.$message.error(resp.data.msg);
          }
        },function(){});
    },
    /**
     * 获取省份
     */
    getProvice(){
      var that = this;
      myHttp.getProvince().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.provinceList;
          that.provinces = list;
        }else{
            that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    //查看
    handleEdit(index,row){
      // this.$router.push({name:'reworkHome',params:{id:row.id}})
      this.$router.push('/reworkHome/'+row.projectId)
    },
    //监听区域
    selcetKu(data){

    },
    //监听类型
    selcetFlag(data){

    },
  }
}
</script>

<style>
@import '../../../assets/css/common.css';

</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content{
  height: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  width: 100%;
  height: calc( 100% - 160px );
  overflow: auto;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button{
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}
.head-title{
  height:80px;
  border:0;
  padding-left:50px;
  display:flex;
  /* box-shadow: 3px 3px 6px 4px #ddd; */
  font-size: 20px;
  color: #2058D9;
  border-bottom: 10px solid #ecf0f5;
}
</style>

<style>
    .add-form .el-select .el-input{
      width: 100%;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>